import { zodResolver } from "@hookform/resolvers/zod";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Chip,
  Fab,
  FormControl,
  FormHelperText,
  Input,
  InputAdornment,
  InputBase,
  Stack,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import { alpha, styled } from "@mui/material/styles";
import { useMutation, useQuery } from "@tanstack/react-query";
import { UserContext } from "App";
import breakpoints from "assets/theme/base/breakpoints";
import {
// AddedCustomerData,
  createB2CcustomerApi,
  SkipUserFun,
  addCustomer,
  dataRetriveWhenPageRefresh,
} from "config/Services";
import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { emit, useNativeMessage } from "react-native-react-bridge/lib/web";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { z } from "zod";
import {
  getManagers,
  reedemCheck,
  removeLoyalty,
  validateCashDrawer,
} from "../../../../config/Services";
import AddCustomerComponent from "../../posnavbar/components/addCustomer";
import { useSnackbar } from "../hooks/SnackbarProvider";
import useGetDevice from "../hooks/useGetDevice";
import usePrint from "../hooks/usePrint";
import useWeighingItemModal from "../hooks/useWeighingItemModal";
import { Cart } from "./Cart";
import { Coupons } from "./Coupons";
import "./LoginPage.css";
import "./all-products.css";
import DropDownModal from "./components/dropDownModal";
import TabmodalFirst from "./components/tabModal/tabmodal1";
import TabmodalSecond from "./components/tabModal/tabmodal2";
import BatchSelectionModal from "./components/twoWaykeyboardPaymentPage/components/batch-popup/index";
import {
  addManualItemsGTIN,
  addingProductTime,
  changeMultipleBatchesValue,
  changePrevAddedTime,
  eventTrackerTime,
  incrementManuallyAddedProduct,
  incrementScannedProduct,
  removeProductTimeArray,
  setManuallyRemovedItems,
  setTotalProducts,
} from "./redux/Actions/eventTracker";
import {
  openProductDetailsSearch,
  searchTextRes,
  setDeviceType,
  setMobilePos,
} from "./redux/Actions/paginationActions";
import {
  getEventTimeDetails,
  getFullState,
  getManuallyAddedProduct,
  getMultipleBatchValue,
  getTotalProducts,
} from "./redux/Reducers/eventTrackerReducer";
import { getMobilePos, getRenderType } from "./redux/Reducers/paginationReducer";
import { removeFromLocalStorage } from "../../../../utils/localStorageHelpers";
import {
  isStaleCartError,
  clearStaleCartStorage,
  showStaleCartDialog,
  isNoCartError,
  showNoCartDialog,
} from "../../../../utils/staleCartHandler";
import { useAddToCart } from "../hooks/useAddToCart";

const schema = z.object({
  userPin: z.string().nonempty("Enter User Pin"),
  managerPin: z.string().nonempty("Enter Manager Pin"),
  selectedManager: z.object({
    uidx: z.string().nonempty("Select Manager"),
    name: z.string().nonempty("Select Manager"),
    selected: z.boolean(),
  }),
});

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#F3F6F9" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

const CashDrawerModal = ({ setDrawerModal }) => {
  const { color, setColor } = useContext(UserContext);
  const showSnackbar = useSnackbar();
  const { openDrawer } = usePrint();

  const [userVisible, setUserVisible] = useState(false);
  const [managerVisible, setManagerVisible] = useState(false);
  const [managerList, setManagerList] = useState([]);

  const locId = localStorage.getItem("locId");
  const userUidx = JSON.parse(localStorage.getItem("retailUserDetails")).uidx;

  const managersQuery = useQuery(["managers"], () => getManagers({ contextId: locId }), {
    retry: 2,
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      if (!res?.data?.data?.length) {
        showSnackbar("No managers found", "error");
        return;
      }
      const managers = res?.data?.data?.map((manager) => {
        return {
          uidx: manager.uidx,
          name: manager.first_name,
          selected: false,
        };
      });
      setManagerList(managers);
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const checkPin = useMutation({
    mutationFn: (payload) => validateCashDrawer(payload),
    onSuccess: (res) => {
      showSnackbar("Cash drawer opened successfully", "success");
      openDrawer();
      setDrawerModal(false);
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
      // setPrint(false)
    },
  });

  const handleManager = (event) => {
    setManagerList((prevState) =>
      prevState.map((manager) => {
        if (manager.name === event.target.innerText) {
          setValue("selectedManager", manager);
          return { ...manager, selected: true };
        } else {
          return { ...manager, selected: false };
        }
      })
    );
    trigger("selectedManager");
  };

  const handleSubmitData = () => {
    const payload = {
      managerUidx: getValues("selectedManager").uidx,
      managerPin: getValues("managerPin"),
      userUidx: userUidx,
      userPin: getValues("userPin"),
    };
    checkPin.mutate(payload);
  };

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      userPin: "",
      managerPin: "",
      selectedManager: {},
    },
    mode: "onBlur",
    resolver: zodResolver(schema),
  });

  const canSubmit = checkPin.isLoading || !isValid;

  return (
    <Box
      sx={{
        backgroundColor: color === "dark" ? "#353a50" : "#fff",
        color: color === "dark" ? "white" : "black",
        padding: "2%",
        borderRadius: "10px",
        width: "25%",
        maxWidth: "100vw",
        maxHeight: "100%",
        position: "fixed",
        top: "50%",
        left: "25%",
        transform: "translate(50%, -50%)",
        overflowY: "auto",
      }}
    >
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Open Cash Drawer
      </Typography>

      <form onSubmit={handleSubmit(handleSubmitData)}>
        <FormControl
          sx={{ width: "100%", marginTop: "1rem" }}
          error={!!errors.userPin}
          variant="outlined"
        >
          <Input
            {...register("userPin")}
            type={userVisible ? "text" : "password"}
            className="modal-input"
            placeholder="User PIN"
            autoFocus
            disableUnderline
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  tabIndex={-1}
                  aria-label="toggle password visibility"
                  onClick={() => setUserVisible((prevState) => !prevState)}
                  edge="end"
                >
                  {userVisible ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          {errors.userPin && (
            <FormHelperText id="component-error-text">{errors.userPin?.message}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          sx={{ width: "100%", marginTop: "1rem" }}
          error={!!errors.managerPin}
          variant="outlined"
        >
          <Input
            {...register("managerPin")}
            type={managerVisible ? "number" : "password"}
            className="modal-input"
            placeholder="Manager PIN"
            inputProps={{ inputMode: "numeric" }}
            disableUnderline
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  tabIndex={-1}
                  aria-label="toggle password visibility"
                  onClick={() => setManagerVisible((prevState) => !prevState)}
                  edge="end"
                >
                  {managerVisible ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          {errors.managerPin && (
            <FormHelperText id="component-error-text">{errors.managerPin?.message}</FormHelperText>
          )}
        </FormControl>
        <div style={{ margin: "1rem 0" }}>
          {managersQuery.isLoading || managersQuery.isFetching ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress color="success" sx={{ color: "#5271ff" }} size={30} />
            </Box>
          ) : (
            managerList.map(({ name, selected }, i) => (
              <Chip
                key={i}
                variant={selected ? "filled" : "outlined"}
                color="info"
                onClick={handleManager}
                label={name}
                style={{ marginRight: "5px" }}
              />
            ))
          )}
          {errors.selectedManager && (
            <p style={{ fontSize: "0.75rem", color: "#d32f2f" }}>{`Select a manager`}</p>
          )}
        </div>
        <div>
          <button
            type="submit"
            className="openBtn"
            style={{
              opacity: canSubmit ? 0.5 : 1,
              cursor: canSubmit ? "not-allowed" : "pointer",
            }}
            disabled={canSubmit}
          >
            {checkPin.isLoading ? (
              <CircularProgress color="success" sx={{ color: "#fff", display: "flex" }} size={20} />
            ) : (
              "OPEN"
            )}
          </button>
        </div>
      </form>
    </Box>
  );
};

export const AllProducts = () => {
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const { addItemWithCheck, addItemDirect } = useAddToCart();
  const { findWeighingItem, renderWeighingModal } = useWeighingItemModal();
  const [customerName, setCustomerName] = useState("");
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");
  const [addModelLoader, setAddModelLoader] = useState(false);
  const [skipModelLoader, setSkipModelLoader] = useState(false);
  const [whatsAppCheck, setWhatsAppCheck] = useState(false);
  const navigate = useNavigate();
  const { color, setColor } = useContext(UserContext);
  const { cartItems, setCartItems } = useContext(UserContext);
  const { cartId, setCartId } = useContext(UserContext);
  const { subTotal, setSubTotal } = useContext(UserContext);
  const { total, setTotal } = useContext(UserContext);
  const { cgst, setCgst } = useContext(UserContext);
  const { sgst, setSgst, searchText, setOfferFound, offerFound, setCess, setHighlightedCartProductId } = useContext(UserContext);
  const [customerMobile, setCustomerMobile] = useState(
    JSON.parse(localStorage.getItem("customer_details"))?.mobileNumber || ""
  );
  const [responseCartTimes, setResponseCartTimes] = useState(
    JSON.parse(localStorage.getItem("responseCartTimes")) || []
  );
  const [isBatchSelected, setIsBatchSelected] = useState(true);

  const [open, setOpen] = useState(false);
  const [redeemLoader, setRedeemLoader] = useState(false);
  const [redeemLoaderarrow, setRedeemLoaderarrow] = useState(false);
  const { loyaltyPoints, setLoyaltyPoints } = useContext(UserContext);
  const { cartCoupon, setCartcoupon } = useContext(UserContext);
  const { particularCategoryItems, setparticularCategoryItems } = useContext(UserContext);
  const [managerVisible, setManagerVisible] = useState(false);

  const [status, setStatus] = useState(false);
  const [noresults, setNoresults] = useState(true);
  const [
    addItemThroughParticularCategoryItemLoader,
    setAddItemThroughParticularCategoryItemLoader,
  ] = useState(null);
  const [selectedMrp, setSelectedMrp] = useState("");
  const [SelectedSellingPrice, setSelectedSellingPrice] = useState("");

  const [selectedGtin, setSelectedGtin] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [drawerModal, setDrawerModal] = useState(false);
  const searchTextValue = useSelector((state) => state.pagination.searchText);
  const searchTextValueI = useSelector((state) => state.pagination.searchTextI);
  const searchLoader = useSelector((state) => state.pagination.loading);
  const { highlightMrp, setHighlightMrp } = useContext(UserContext);
  const [isExploding, setIsExploding] = useState(false);

  const [addItemResponseTime, setAddItemResponseTime] = useState(() => {
    const item = localStorage.getItem("addItemResponseTime");
    try {
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.error("Error parsing addItemResponseTime from localStorage", error);
      return [];
    }
  });
  const [sellingUnit, setSellingUnit] = useState("");

  const appDrawer = useSelector((state) => state.pagination.appDrawer);
  const [showCamera, setShowCamera] = useState(false);
  const getDrawerStatus = () => window.innerWidth < breakpoints.values.sm;
  const isMobilePos = useSelector(getMobilePos);
  const renderType = useSelector(getRenderType);
  const [brandName, setBrandName] = useState("");
  const [packagingType, setPackagingType] = useState("");
  const [variantName, setVariantName] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [availableUnits, setAvailableUnits] = useState("");

  useNativeMessage(async (message) => {
    const data = JSON.parse(message?.data);
    switch (message?.type) {
      case "webView": {
        if (data?.machine === "edc") {
          dispatch(setMobilePos(true));
        }
        dispatch(setDeviceType(data?.machine));
        break;
      }
      default:
        break;
    }
  });

  const dispatch = useDispatch();

  const handleOpen = () => setOpen(true);

  const [disableCustomerModalClose, setDisableCustomerModalClose] = useState(false);

  useEffect(() => {
    if (!open) setDisableCustomerModalClose(false);
  }, [open]);

  /* Open customer modal programmatically — triggered by showNoCartDialog()
   * so the operator can create a cart immediately after a "no cart" error. */
  useEffect(() => {
    const openCustomerModal = () => {
      setDisableCustomerModalClose(true);
      setOpen(true);
    };
    window.addEventListener("pallet:open-customer-modal", openCustomerModal);
    return () => window.removeEventListener("pallet:open-customer-modal", openCustomerModal);
  }, []);

  const location = useLocation();
  const { pathname } = location;

  const sessionId = localStorage.getItem("sessionId");
  const licenseId = localStorage.getItem("licenseId");
  const locationId = localStorage.getItem("locId");
  const organizationId = localStorage.getItem("orgId");

  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));
  let retailUserID = JSON.parse(localStorage.getItem("retailUserDetails"))?.uidx;

  let retail_payload = {
    userName: null,
    userId: null, //uidx customer created
    mobileNo: null,
    createdBy: retailUserLocalStorageData?.firstName, // first name+lastname
    locationId: locationId || "", // skip
    sourceId: organizationId, // org-id
    loggedInUser: retailUserLocalStorageData?.uidx, //uidx login user
    sourceLocationId: locationId, //
    sourceType: retailUserLocalStorageData?.contexts?.POS_USER?.meta[0].type,
    sourceApp: "PALLET_POS",
    destinationId: organizationId,
    destinationLocationId: locationId,
    destinationType: retailUserLocalStorageData?.contexts?.POS_USER?.meta[0].type,
    comments: null,
    sessionId: sessionId || null,
    orderType: "POS_ORDER",
    subOrderType: isMobile ? "MPOS_ORDER" : "POS_ORDER",
    licenseId: licenseId || null,
    hoId: null,
    channel: "POS",
  };

  const handleClose = () => {
    setSkipModelLoader(true);
    SkipUserFun({ ...retail_payload, sessionId, licenseId })
      .then((res) => {
        if (res?.data?.status === "error" || res?.data?.status === "ERROR" || res?.data?.data?.es > 0) {
          const errMsg = res?.data?.message || res?.data?.data?.message || "";
          if (isStaleCartError(errMsg)) {
            clearStaleCartStorage();
            setCartId(null);
            showStaleCartDialog();
          } else {
            showSnackbar(errMsg || "Something went wrong while creating cart", "error");
          }
          setSkipModelLoader(false);
          return;
        }
        const customer_details = {
          name: null,
          mobileNumber: null,
          uidx: null,
          whatsapp: false,
        };
        if (!cartItems.length) {
          const currentTime = new Date().getTime();
          dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
          dispatch(changePrevAddedTime(currentTime));
          const orderMetricData = {
            startTime: currentTime,
            prevAddedProductTime: currentTime,
            startTimeAdded: true,
            manuallyAdded: 0,
            scannedProduct: 0,
            isMultipleBatch: false,
            avgProductAddTime: "",
            totalProducts: 0,
            productTimeArray: [],
            editOrderItem: 0,
            manuallyRemovedItems: 0,
            manualItemsGtin: [],
          };
          localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
        }
        showSnackbar("Cart Added success", "success");
        setCartId(res.data.data.cartId);
        setCartItems(res.data.data.cartProducts || []);
        setCgst(res.data.data.billing.cgst);
        setSgst(res.data.data.billing.sgst);
        setCess(res.data.data.billing.totalCessAmount);
        setSubTotal(res.data.data.billing.totalCartValue);
        setTotal(res.data.data.billing.totalCartValue);
        setSkipModelLoader(false);
        setOpen(false);
        setCustomerMobile("");
        localStorage.setItem("CartId", res.data.data.cartId);
        localStorage.setItem("customer_details", JSON.stringify(customer_details));
        isMobilePos &&
          emit({
            type: "localData",
            data: {
              CartId: res.data.data.cartId,
              customer_details: customer_details,
            },
          });
      })
      .catch((err) => {
        const errMsg = err?.response?.data?.message || err?.message || "";
        if (isStaleCartError(errMsg)) {
          clearStaleCartStorage();
          setCartId(null);
          showStaleCartDialog();
        } else {
          showSnackbar(errMsg, "error");
        }
        setSkipModelLoader(false);
      });
  };

  useEffect(() => {
    if (location?.state?.isOrderEditing) {
      const currentTime = new Date().getTime();
      dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
      dispatch(changePrevAddedTime(currentTime));
      dispatch(setManuallyRemovedItems(0));
      dispatch(setTotalProducts(0));
      dispatch(incrementManuallyAddedProduct(0));
      dispatch(incrementScannedProduct(0));
      dispatch(removeProductTimeArray(0));
      const backupData = {
        ...orderMetricDataFullState,
        startTime: currentTime,
        startTimeAdded: true,
        prevAddedProductTime: currentTime,
        totalProducts: 0,
        manuallyAdded: 0,
        scannedProduct: 0,
        manuallyRemovedItems: 0,
        avgProductAddTime: "",
      };
      localStorage.setItem("orderMetricData", JSON.stringify(backupData));
    }
  }, [location?.state?.isOrderEditing]);

  // add customer Functionality implemented

  useEffect(() => {
    setStatus(false);
    if (localStorage.getItem("CartId") && !cartItems?.length) {
      let cartId = localStorage.getItem("CartId");
      dataRetriveWhenPageRefresh(cartId)
        .then((res) => {
          setCartId(res?.data?.data?.data?.cartId);
          setCartItems(res?.data?.data?.data?.cartProducts);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing?.totalCessAmount);
          setSubTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setLoyaltyPoints(res?.data?.data?.data?.loyaltyPointsValue);
          setCartcoupon(res?.data?.data?.data?.cartCoupon);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          if (
            err?.response?.data?.message ===
            "Unable to fetch cart details. :: Cart is already closed please create new cart."
          ) {
            removeFromLocalStorage("CartId");
            handleOpen();
          }
        });
    }
  }, []);

  const [customerSuccess, setCustomerSuccess] = useState(false);
  const orgId = localStorage.getItem("orgId");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const uidx = retailUserDetails?.uidx;
  const [mrps, setMrps] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [batchNo, setBatchNo] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [couponApplied, setCouponApplied] = useState("0");
  const [appliedState, setAppliedState] = useState(false);
  const [offerData, setOfferData] = useState(null);
  useEffect(() => {
    if (particularCategoryItems?.length != 0 && searchTextValue !== "") {
      setStatus(true);
    } else {
      setNoresults(true);
      setStatus(false);
      // dispatch(searchTextRes(""));
    }
  }, [particularCategoryItems, pathname, searchTextValue]);

  const addCustomerFun = () => {
    let addCustomerPayload = {
      mobile: customerMobileNumber,
      firstName: customerName,
    };
    if (customerMobileNumber.length !== 10) {
      showSnackbar("Enter a valid mobile number", "warning");
    } else {
      setAddModelLoader(true);
      addCustomer(addCustomerPayload).then((res) => {
        let customerUidxData = {
          uidx: res.data.data.uidx,
          phoneNumber: customerMobileNumber,
          name: customerName,
          organizationId: orgId,
          createdBy: retailUserID,
          locationId: locId,
          sessionId: sessionId,
          platform: "POS"
        };
        /*
        AddedCustomerData(customerUidxData)
        */
        createB2CcustomerApi(customerUidxData)
          .then((res) => {
            retail_payload.userName = customerName;
            retail_payload.mobileNo = customerMobileNumber;
            retail_payload.userId = customerUidxData.uidx;
            SkipUserFun({ ...retail_payload, licenseId, sessionId })
              .then((res) => {
                const customer_details = {
                  name: customerName,
                  mobileNumber: customerMobileNumber,
                  uidx: customerUidxData.uidx,
                  whatsapp: whatsAppCheck,
                };
                if (!cartItems.length) {
                  const currentTime = new Date().getTime();
                  dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
                  dispatch(changePrevAddedTime(currentTime));
                  const orderMetricData = {
                    startTime: currentTime,
                    prevAddedProductTime: currentTime,
                    startTimeAdded: true,
                    manuallyAdded: 0,
                    scannedProduct: 0,
                    isMultipleBatch: false,
                    avgProductAddTime: "",
                    totalProducts: 0,
                    productTimeArray: [],
                    editOrderItem: 0,
                    manuallyRemovedItems: 0,
                    manualItemsGtin: [],
                  };
                  localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
                }
                showSnackbar("Cart Added success", "success");
                setCartId(res.data.data.cartId);
                setCartItems(res.data.data.cartProducts);
                setCgst(res.data.data.billing.cgst);
                setSgst(res.data.data.billing.sgst);
                setCess(res.data.data.billing.totalCessAmount);
                setSubTotal(res.data.data.billing.totalCartValue);
                setTotal(res.data.data.billing.totalCartValue);
                retail_payload.userName = null;
                retail_payload.mobileNo = null;
                retail_payload.userId = null;
                localStorage.setItem("CartId", res.data.data.cartId);
                localStorage.setItem("customer_details", JSON.stringify(customer_details));
                isMobilePos &&
                  emit({
                    type: "localData",
                    data: {
                      CartId: res.data.data.cartId,
                      customer_details: customer_details,
                    },
                  });
                setCustomerMobile(customerMobileNumber);
                setCustomerSuccess(true);
                setCustomerName("");
                setCustomerMobileNumber("");
                setAddModelLoader(false);
                setOpen(false);
              })
              .catch((err) => {
                showSnackbar(err?.response?.data?.message || err?.message, "error");
                setAddModelLoader(false);
              });
          })
          .catch((err) => {
            showSnackbar(err?.response?.data?.message || err?.message, "error");
          });
      });
    }
  };

  let customerUidx = JSON.parse(localStorage.getItem("customer_details"))?.uidx;
  const [sellingprice, setSellingprice] = useState("");

  //redeem check to get true false value:

  const [redeemableIfCouponApplied, setredeemableIfCouponApplied] = useState("");
  const reedeemCheckData = () => {
    reedemCheck(orgId).then((res) => {
      setredeemableIfCouponApplied(res?.data?.data?.redeemableIfCouponApplied);
    });
  };

  useEffect(() => {
    setparticularCategoryItems([]);
    setStatus(false);
    reedeemCheckData();
  }, [pathname]);

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "y" && e.ctrlKey) {
        navigate("/products/coupons");
        e.preventDefault();
      }
      if (e.key === "j" && e.ctrlKey) {
        navigate("/products/points");
        e.preventDefault();
      }
    });
  }, []);

  const { animationBox, setanimationBox } = useContext(UserContext);
  const { gtinItem, setItemgtin } = useContext(UserContext);
  const locId = localStorage.getItem("locId");
  const totalProducts = useSelector(getTotalProducts);
  const manuallyAddedProducts = useSelector(getManuallyAddedProduct);
  const eventTime = useSelector(getEventTimeDetails);
  const orderMetricDataFullState = useSelector(getFullState);

  useEffect(() => {
    if (!eventTime.startTimeAdded) {
      const currentTime = new Date().getTime();
      dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
      if (!cartItems.length) {
        const currentTime = new Date().getTime();
        dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
        dispatch(changePrevAddedTime(currentTime));
        const orderMetricData = {
          ...orderMetricDataFullState,
          startTime: currentTime,
          prevAddedProductTime: currentTime,
          startTimeAdded: true,
        };
        localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
      }
    }
  }, [eventTime]);

  const increseItemQuantityTroughParticularCategory = (
    gtin,
    name,
    index,
    packaging_type,
    sellingUnit
  ) => {
    const initialTime = new Date().getTime();
    setAddItemThroughParticularCategoryItemLoader(index);
    let payload = {
      gtin: gtin,
      cartId: cartId,
      locationId: locId,
      orgId: orgId,
    };
    const start = new Date().getTime();
    if (findWeighingItem(gtin, name, packaging_type, sellingUnit)) {
      setAddItemThroughParticularCategoryItemLoader(false);
      return;
    }
    // Error handling (stale cart, no cart, generic) delegated to useAddToCart hook
    addItemWithCheck(payload, {
      onBeforeError: () => {
        setIsBatchSelected(false);
        setAddItemThroughParticularCategoryItemLoader(false);
      },
      onBatchSelect: (dataArr) => {
        setIsBatchSelected(true);
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...addItemResponseTime,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
          setAddItemResponseTime(updatedResponseTimes);
        }
        dispatch(changeMultipleBatchesValue(true));
        localStorage.setItem("orderMetricData", JSON.stringify({
          ...orderMetricDataFullState, isMultipleBatch: true,
        }));
        setBrandName(dataArr?.[0]?.brand);
        setPackagingType(dataArr?.[0]?.packagingType);
        setVariantName(dataArr?.[0]?.variantName);
        setVendorId(dataArr?.[0]?.vendorId);
        setExpiryDate(dataArr?.[0]?.expiryDate || "");
        setMrps(dataArr);
        setOfferData(dataArr?.[0]?.offers);
        setSelectedMrp(dataArr?.[0]?.mrp);
        setSelectedSellingPrice(dataArr?.[0]?.sellingPrice);
        setBatchNo(dataArr?.[0]?.batchNum);
        setPurchasePrice(dataArr?.[0]?.purchasePrice || "");
        setSelectedGtin(dataArr?.[0]?.gtin);
        setSellingUnit(dataArr?.[0]?.sellingUnit);
        setSelectedProduct(name);
        setOpen(false);
        setOpenModal(true);
        setanimationBox(true);
        setItemgtin(gtin);
        setHighlightMrp(dataArr?.[0]?.sellingPrice);
      },
      onSuccess: (response) => {
        // Cart state (cartItems, billing, offerFound) applied by useAddToCart hook
        setIsBatchSelected(true);
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...addItemResponseTime,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
          setAddItemResponseTime(updatedResponseTimes);
        }
        setCouponApplied(response?.billing?.appliedCoupon);
        setAppliedState(!appliedState);
        setAddItemThroughParticularCategoryItemLoader(null);
        setSelectedMrp("");
        setSelectedSellingPrice("");
        setBatchNo("");
        setPurchasePrice("");
        setSelectedGtin("");
        setSelectedProduct("");
        setOfferData(null);
        setMrps([]);
        setanimationBox(true);
        setItemgtin(gtin);
        setHighlightMrp(response?.cartProducts?.[0]?.sellingPrice);
        setOpen(false);
        dispatch(searchTextRes(""));
        const currentTime = new Date().getTime();
        dispatch(addingProductTime(currentTime - initialTime));
        dispatch(incrementManuallyAddedProduct(manuallyAddedProducts + 1));
        dispatch(setTotalProducts(totalProducts + 1));
        dispatch(addManualItemsGTIN(gtin));
        const backupData = {
          ...orderMetricDataFullState,
          manuallyAdded: manuallyAddedProducts + 1,
          totalProducts: totalProducts + 1,
          productTimeArray: [
            ...orderMetricDataFullState.productTimeArray,
            currentTime - initialTime,
          ],
          manualItemsGtin: orderMetricDataFullState.manualItemsGtin.includes(gtin)
            ? [...orderMetricDataFullState.manualItemsGtin]
            : [...orderMetricDataFullState.manualItemsGtin, gtin],
        };
        localStorage.setItem("orderMetricData", JSON.stringify(backupData));
      },
    });
  };

  const isProfilerOn =
    // useMemo(() => {
    localStorage.getItem("profilerSwitch") === "true";
  // }, []);

  const multipleBatchCheck = useSelector(getMultipleBatchValue);

  const addItem = (
    gtin,
    mrp,
    sp,
    batchNo,
    purchasePrice,
    sellingUnit,
    offer,
    availableUnits,
    expiryDate,
    brand,
    packagingType,
    itemName,
    vendorId
  ) => {
    const initialTime = new Date().getTime();
    setHighlightMrp(sp);
    let payload = {
      cartId: cartId,
      gtin: gtin.gtin,
      sellingPrice: sp,
      locationId: locId,
      mrp: mrp,
      inventoryChecks: "NO",
      batchNo: batchNo || "",
      purchasePrice: purchasePrice || "",
      isOfferAvailable: offer?.length > 0 ? true : false,
      sellingUnit: sellingUnit,
      expiryDate: expiryDate?.split("+")[0],
      variantName: itemName,
      vendorId: vendorId,
      packagingType: packagingType,
      brandName: brand,
    };

    const start = new Date().getTime();

    // Error handling (stale cart, no cart, generic) delegated to useAddToCart hook
    return addItemDirect(payload, cartItems, {
      onBeforeError: () => {
        setAddItemThroughParticularCategoryItemLoader(null);
      },
      onSuccess: (cartData) => {
        setIsBatchSelected(false);
        //cart-response-times
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...responseCartTimes,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("responseCartTimes", JSON.stringify(updatedResponseTimes));
          setResponseCartTimes(updatedResponseTimes);
          if (multipleBatchCheck) {
            const currentTime = new Date().getTime();
            dispatch(incrementManuallyAddedProduct(manuallyAddedProducts + 1));
            dispatch(setTotalProducts(totalProducts + 1));
            dispatch(addingProductTime(currentTime - initialTime));
            dispatch(changeMultipleBatchesValue(false));
            dispatch(addManualItemsGTIN(selectedGtin || gtin));
            localStorage.setItem("orderMetricData", JSON.stringify({
              ...orderMetricDataFullState,
              manuallyAdded: manuallyAddedProducts + 1,
              isMultipleBatch: false,
              totalProducts: totalProducts + 1,
              productTimeArray: [
                ...orderMetricDataFullState?.productTimeArray,
                currentTime - initialTime,
              ],
              manualItemsGtin: orderMetricDataFullState?.manualItemsGtin.includes(
                selectedGtin || gtin
              )
                ? [...orderMetricDataFullState?.manualItemsGtin]
                : [...orderMetricDataFullState?.manualItemsGtin, selectedGtin || gtin],
            }));
          }
        }
        showSnackbar("Item added successfully", "success");
        // Cart state (cartItems, billing, offerFound) applied by useAddToCart hook
        const sortedProducts = [...(cartData?.cartProducts || [])].sort((a, b) =>
          (b.modifiedDate || b.createdDate || "").localeCompare(a.modifiedDate || a.createdDate || "")
        );
        if (sortedProducts?.[0]?.cartProductId) {
          setHighlightedCartProductId(sortedProducts[0].cartProductId);
          setTimeout(() => setHighlightedCartProductId(null), 2000);
        }
        setCouponApplied(cartData?.billing?.appliedCoupon);
        setAppliedState(!appliedState);
        setAddItemThroughParticularCategoryItemLoader(null);
        setSelectedMrp("");
        setBatchNo("");
        setPurchasePrice("");
        setSelectedSellingPrice("");
        setSelectedGtin("");
        setSelectedProduct("");
        setMrps([]);
        setanimationBox(true);
        setItemgtin(gtin);
      },
    });
  };

  useEffect(() => {
    const activeCartId = localStorage.getItem("CartId");

    if (loyaltyPoints && activeCartId) {
      removeLoyalty(activeCartId).then((res) => {
        // showSnackbar("Successfully removed loyalty", "success");
        localStorage.removeItem("loyaltyPoints");
        setTotal(res?.data?.data?.billing?.totalCartValue);
        setLoyaltyPoints(res?.data?.data?.loyaltyPointsValue);
      });
    }
  }, [cartItems, couponApplied, appliedState]);

  const handleModalClose = () => {
    setIsBatchSelected(false);
    setOpenModal(false);
    setAddItemThroughParticularCategoryItemLoader(null);
  };

  const handleBackSearch = () => {
    setparticularCategoryItems([]);
    setStatus(false);
  };

  useEffect(() => {
    document.addEventListener("keyup", (e) => {
      if (e.key == "Escape") {
        handleBackSearch();
      }
    });

    return () => document.removeEventListener("keyup", handleBackSearch);
  }, []);

  const handlePrice = (mrp, sp, batchNo, purchasePrice, selling_unit, offers) => {
    setSelectedMrp(mrp);
    setSelectedSellingPrice(sp);
    setBatchNo(batchNo);
    setPurchasePrice(purchasePrice);
    setOfferData(offers);
    setIsBatchSelected(false);
  };

  if (cartItems?.length === 0) {
    localStorage.removeItem("loyaltyPoints");
  }

  const fabGreenStyle = {
    color: "#0562FB",
    border: "3px solid #0562FB !important",
    backgroundColor: color === "dark" ? "rgb(43,47,66)" : "rgb(255,255,255)",
    height: "37px !important",
    boxShadow: "none",
    "&:hover": {
      color: "white",
      backgroundColor: "#0562FB",
    },
  };

  const navigateToParticluarCategory = () => {
    navigate("/restaurant/cart");
  };

  return (
    <>
      <Navbar pageTitle={"Cart"}>
        <Box
          className={color}
          style={{ display: "flex", flex: 1, flexDirection: "column", marginTop: "1rem" }}
        >
          {searchText && isMobile && <DropDownModal />}

          {renderWeighingModal()}
          <BatchSelectionModal
            open={openModal}
            onClose={handleModalClose}
            mrps={mrps}
            disabled={isBatchSelected}
            selectedProduct={selectedProduct}
            selectedGtin={selectedGtin}
            handlePrice={handlePrice}
            addItemWithScanner={addItem}
            selectedMrp={selectedMrp}
            SelectedSellingPrice={SelectedSellingPrice}
            batchNo={batchNo}
            purchasePrice={purchasePrice}
            sellingUnit={sellingUnit}
            offerData={offerData}
            availableUnits={availableUnits}
            expiryDate={expiryDate}
            brandName={brandName}
            packagingType={packagingType}
            variantName={variantName}
            vendorId={vendorId}
          />

          {open ? (
            <div>
              <AddCustomerComponent
                open={open}
                setOpen={setOpen}
                cartItems={cartItems}
                setCartItems={setCartItems}
                disableClose={disableCustomerModalClose}
              />
            </div>
          ) : (
            <Stack className="cart-container">
              <Grid
                container
                className="all-products-container"
                sx={{ width: appDrawer ? "calc(100vw - 85px)" : "100%" }}
              >
                {!isMobile && (
                  <Grid item xs={12} md={6.4} className="leftContainer-all">
                    {renderType === "coupons" ? (
                      <Coupons />
                    ) : (
                      <>
                        <div className="categoryText">
                          <h4>Categories</h4>
                        </div>
                        <TabmodalSecond />
                        {!status && searchLoader ? (
                          <div className="searchLoader">
                            <CircularProgress color="success" sx={{ color: "#5271ff" }} size={50} />
                          </div>
                        ) : !status ? (
                          <>
                            <h4 className="customers">Customers</h4>
                            <TabmodalFirst setOpen={setOpen} />

                            <Box className="all-products-icon-cont">
                              <IconButton
                                onClick={() => setDrawerModal(true)}
                                className="editicon"
                                aria-label="Example"
                              >
                                <CurrencyExchangeIcon />
                              </IconButton>
                              <Box>
                                <Fab
                                  aria-label="add"
                                  variant="extended"
                                  sx={{ ...fabGreenStyle }}
                                  onClick={() => dispatch(openProductDetailsSearch(true))}
                                >
                                  <ManageSearchIcon />
                                </Fab>
                              </Box>
                            </Box>
                            <Modal
                              open={drawerModal}
                              onClose={() => setDrawerModal(false)}
                              aria-labelledby="modal-modal-title"
                              aria-describedby="modal-modal-description"
                            >
                              <CashDrawerModal setDrawerModal={setDrawerModal} />
                            </Modal>
                          </>
                        ) : status && searchLoader ? (
                          <div className="searchLoader">
                            <CircularProgress color="success" sx={{ color: "#5271ff" }} size={50} />
                          </div>
                        ) : (
                          status && (
                            <>
                              <div
                                onClick={handleBackSearch}
                                style={{ border: "none", padding: "10px", marginTop: "1rem" }}
                                className="navigate-wrapper-product-box"
                              >
                                <KeyboardBackspaceIcon className="paymentPageBackBtn" />
                              </div>
                              <h4 className="search-results-text">Search Results</h4>
                              <div
                                id="mainHeader"
                                className="particularCategoryEachItemGridContainer"
                              >
                                {particularCategoryItems?.length > 0 ? (
                                  particularCategoryItems.map((ele, index) => {
                                    return (
                                      <div
                                        key={ele?.variant?.barcodes[0]}
                                        className="particularCategoryEachItem"
                                      >
                                        <img
                                          className="particularCategoryEachItemImg"
                                          src={
                                            ele?.variant?.images?.front ||
                                            ele?.variant?.images?.back ||
                                            ele?.variant?.images?.left ||
                                            ele?.variant?.images?.right ||
                                            ele?.variant?.images?.top ||
                                            ele?.variant?.images?.bottom ||
                                            ele?.variant?.images?.top_left ||
                                            ele?.variant?.images?.top_right ||
                                            "https://tse4.mm.bing.net/th?id=OIP.mPwk4FItjNeb2Oaq8F1u9QHaGE&pid=Api&P=0"
                                          }
                                          alt="err"
                                        />
                                        <p
                                          style={{
                                            fontSize: "0.8rem",
                                            paddingLeft: "7px",
                                            paddingRight: "7px",
                                            height: "5.5vh",
                                            overflow: "hidden",
                                            minHeight: "5.5vh",
                                            textTransform: "capitalize",
                                          }}
                                          className="particularElementName"
                                        >
                                          {ele?.variant?.name || ele?.name}
                                        </p>
                                        <div className="weight-wrapper-box">
                                          <p>{ele?.variant?.weight}</p>
                                          <p>{ele?.variant?.weight_unit}</p>
                                        </div>

                                        <div
                                          style={{
                                            display: "flex",
                                            flex: 1,
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            fontSize: "1rem",
                                            paddingLeft: "7px",
                                            paddingRight: "7px",
                                          }}
                                        >
                                          <p style={{ flex: 0.7, display: "flex" }}>
                                            ₹{ele?.variant?.inventorySync?.mrp}
                                          </p>
                                          {addItemThroughParticularCategoryItemLoader === index ? (
                                            <CircularProgress
                                              color="success"
                                              sx={{ color: "#5271ff" }}
                                              size={25}
                                            />
                                          ) : (
                                            <button
                                              className="add-item-btn"
                                              onClick={() =>
                                                increseItemQuantityTroughParticularCategory(
                                                  ele?.variant?.barcodes[0],
                                                  ele?.variant?.name || ele?.name,
                                                  index,
                                                  ele?.variant?.needsWeighingScaleIntegration ===
                                                    true
                                                    ? "weighingScale"
                                                    : "Standard",
                                                  ele?.variant?.weightUnit
                                                )
                                              }
                                            >
                                              +
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      width: "100%",
                                    }}
                                  >
                                    {noresults ? (
                                      <p className="no-data-wrapper-text">NO RESULT FOUND</p>
                                    ) : (
                                      <CircularProgress
                                        color="success"
                                        sx={{ color: "#5271ff" }}
                                        size={30}
                                      />
                                    )}
                                  </Box>
                                )}
                              </div>
                            </>
                          )
                        )}
                      </>
                    )}
                  </Grid>
                )}
                <Cart
                  handleOpen={handleOpen}
                  managerDetails={location}
                  isOrderEditing={location?.state?.isOrderEditing}
                />
              </Grid>
            </Stack>
          )}
        </Box>
      </Navbar>
    </>
  );
};
